var _rect, _path, _path2, _rect2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTargetgroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "svg-icon",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-color-main",
    x: 123.032,
    y: 38.189,
    width: 43.85,
    height: 53.889,
    rx: 21.925,
    ry: 21.925
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "stroke-color-main",
    d: "M124.46,95.191a49.579,49.579,0,0,0-11.447,7.4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "stroke-color-main",
    d: "M136.388,148.982q5.266.526,10.534.527h1a112.483,112.483,0,0,0,43.949-9.217l1.844-.778v-2a45.827,45.827,0,0,0-28.5-42.368"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "stroke-color-main",
    x: 39.31,
    y: 32.16,
    width: 53.446,
    height: 65.682,
    rx: 26.723,
    ry: 26.723
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "stroke-color-main",
    d: "M59.863,125.084,43.8,108.433l-2.746-6.8c-19.171,8.858-34.765,29.235-34.765,51.7v2.442l2.25.948a139.035,139.035,0,0,0,46.589,11.048"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "stroke-color-main",
    d: "M90.723,101.58l-2.742,6.777-17.23,17.849a16.954,16.954,0,0,0-4.78,11.834v29.743c1.225.035,2.45.057,3.675.057a137.084,137.084,0,0,0,53.566-11.234l2.248-.948v-2.439A55.856,55.856,0,0,0,90.723,101.58Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTargetgroup);
export default __webpack_public_path__ + "static/media/targetgroup.657496e77a3067e5d7fe5560f3aa4d4e.svg";
export { ForwardRef as ReactComponent };